import { IComponentConfig } from "@/app/@types/base-component";
import {
    createDoubleFabricProducedDoorConfig,
    createHandleConfig,
    createLockConfig,
    createPatchesSetConfig,
    createRollerSetConfig,
    createSingleFabricProducedDoorConfig,
    createUHolderConfig,
} from "../../configs/hardwares.config";

import { Hardware } from "../../entities/hardware";
import { CreateManyStrategy } from "../base/creation.strategy";
import {
    MinimalPullHandle,
    ModenaLeverBlack,
    NovaConcealedHandle,
} from "@/app/constants/hardwares";

export class SingleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const SINGLE_SWING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().build(),
            createLockConfig().valueNone().build(),
        ];
        super(SINGLE_SWING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}

export class DoubleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const DOUBLE_SWING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().defaultQty(2).qty(2).build(),
            createHandleConfig().defaultQty(2).qty(2).build(),
            createLockConfig().defaultQty(2).qty(2).valueNone().build(),
        ];
        super(DOUBLE_SWING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}

export class SingleSlidingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const SINGLE_SLIDING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createRollerSetConfig().build(),
            createUHolderConfig().build(),
            createHandleConfig().build(),
            createLockConfig().valueNone().build(),
        ];
        super(SINGLE_SLIDING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}

export class DoubleSlidingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const DOUBLE_SLIDING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createRollerSetConfig().defaultQty(2).qty(2).build(),
            createUHolderConfig().defaultQty(2).qty(2).build(),
            createHandleConfig().defaultQty(2).qty(2).build(),
            createLockConfig().defaultQty(2).qty(2).valueNone().qty(2).build(),
        ];
        super(DOUBLE_SLIDING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}

export class KompasSingleDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const KOMPAS_SINGLE_HARDWARES_CONFIG: IComponentConfig[] = [
            createSingleFabricProducedDoorConfig().build(),
        ];
        super(KOMPAS_SINGLE_HARDWARES_CONFIG, Hardware);
    }
}

export class KompasDoubleDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const KOMPAS_DOUBLE_HARDWARES_CONFIG: IComponentConfig[] = [
            createDoubleFabricProducedDoorConfig().build(),
        ];
        super(KOMPAS_DOUBLE_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelSingleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(ModenaLeverBlack).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelDoubleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(ModenaLeverBlack).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelSingleSlidingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(MinimalPullHandle).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelDoubleSlidingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(MinimalPullHandle).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelMultiSlidingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(NovaConcealedHandle).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelFoldingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(NovaConcealedHandle).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelArchSingleDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(ModenaLeverBlack).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}

export class SteelArchDoubleDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const STEEL_SINGLE_SWING_HARDWARES_CONFIG: IComponentConfig[] = [
            createPatchesSetConfig().build(),
            createHandleConfig().structureCode(ModenaLeverBlack).build(),
            createLockConfig().valueNone().build(),
        ];
        super(STEEL_SINGLE_SWING_HARDWARES_CONFIG, Hardware);
    }
}
